module.exports = {
  VirtualTour: {
    background_color: "Color de Fondo",
    PluginName: "Mapa Google",
    border_color: "Color de Borde",
    border_size: "Grosor de Borde",
    border_style: "Estilo de Borde",
    box_style: "Estilo Caja",
    Coords: "Coordenadas",
    opacity: "Opacidad",
    padding: "Padding",
    radius: "Radio",
    map: "Mapa",
    center: "Centro",
    Zoom: "Zoom",
    message_mark_xy:
      "Ha introducido un valor incorrecto. Debe introducir dos números separados por coma. Ej. 4.56,90.76",
    message_mark_xyp:
      "Ha introducido un valor incorrecto. Debe introducir tres números separados por coma. Ej. 4.56,90.76,1",
    Search: "Busca lugares...",
  },
};
